import InitialState from "./InitialState"
import { GET_USERFORM_DATA } from "../actions/ActionTypes";
import { FormTypes } from "../models/UserForm";

export interface UserFormData {
  userResponse: any,
  screenDetails: any
}

interface UserFormAction {
  type: string,
  payload: {
    formType: FormTypes
    data: UserFormData
  }
}

export const UserFormReducer = function (state = InitialState.userform, action: UserFormAction) {
  switch (action.type) {
    case GET_USERFORM_DATA:
      return {
        ...state,
        [action.payload.formType]: action.payload.data
      }
    default:
      return state;
  }
}